import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const PaywallBulkLogsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "PaywallBulkLogsPage" */ "@circle-react/components/SettingsApp/PaywallBulkLogsApp"
    ),
);

export const PaywallBulkLogsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <PaywallBulkLogsComponent />
  </Suspense>
);
